export const state = {
  todosFolderPending: false,
  todosFolder: null,
  todosFolderError: null,
  todosFolderStructurePending: false,
  todosFolderStructure: null,
  todosFolderStructureError: null,
}
